import { RoutePath } from "#src/utils/route";
import { DataToolsRoutePath } from "..";

/** Route path for the worker logs (runs) page. Resolves to /app/data-tools/worker-logs. */
export const WorkerLogsRoutePath = DataToolsRoutePath.concat(
  new RoutePath({
    path: "/worker-logs",
    title: "Worker Run Log",
  })
);
